import { useContext, useEffect } from "react";
import State from "../../Components/Stats/State";
import { MyContext } from "../../Components/Context";

export default function Apercu({detail}){

    const { actifItem, setActifItem } = useContext(MyContext);
    

    useEffect(()=>{
        setActifItem('Annonces')
    }, [])

    
    if(!detail) return null;
    console.log('detail is: ', detail)

    const getDate = (date)=>{
        const created = new Date(date).getFullYear()
        const heute = new Date().getFullYear()

        if(heute - created > 0){
            
            return `${heute - created} ans`
            
        }else{

            const created = new Date(date).getMonth()
            const heute = new Date().getMonth()

            if(heute - created){

                return `${heute - created} mois`
                
            }else{
                const created = new Date(date).getDay()
                const heute = new Date().getDate()

                if(heute - created){
                    
                    return `${heute - created} jours`
                }else{
                    const created = new Date(date).getHours()
                    const heute = new Date().getHours()

                    return `${heute - created} heures`
                    
                }
            }
            

        }
    }

    
    
    return (
        <div style={{flex : 1, justifyContent : 'flex-start', alignItems : 'center',padding : 40}} className="bg-white rounded-lg shadow-md dark:bg-gray-800">
            <div className="flex flex-row flex-wrap items-start w-full gap-5 200 ">
                <div className="px-5 py-2 my-3 bg-gray-100 border-l-4 rounded-xl border-l-purple-600 dark:bg-gray-600">
                    <p className="mt-3 text-lg font-bold text-gray-800 dark:text-gray-200">N° Annonce</p>
                    <p className="mt-2 text-gray-600 dark:text-gray-200">{detail.id}</p>
                </div>

                <div className="px-5 py-2 my-3 bg-gray-100 border-l-4 rounded-xl border-l-purple-600 dark:bg-gray-600">
                    <p className="mt-3 text-lg font-bold text-gray-800 dark:text-gray-200">Date de creation </p>
                    <p className="mt-2 text-gray-600 dark:text-gray-200">{new Date(detail.createdAt).toLocaleDateString()}</p>   
                </div>

                <div className="px-5 py-2 my-3 bg-gray-100 border-l-4 rounded-xl border-l-purple-600 dark:bg-gray-600">
                    <p className="mt-3 text-lg font-bold text-gray-800 dark:text-gray-200">creer depuis </p>
                    <p className="mt-2 text-gray-600 dark:text-gray-200">{getDate(detail.createdAt)}</p>  
                </div>

                <div className="px-5 py-2 my-3 bg-gray-100 border-l-4 rounded-xl border-l-purple-600 dark:bg-gray-600">
                    <p className="text-lg font-semibold text-gray-800 dark:text-gray-200">Statut</p>
                    {
                        detail.isVisible ? 
                        <p className="py-1 pl-3 pr-3 mt-2 text-sm font-bold text-center text-green-800 bg-green-200 rounded-xl ">Publié</p>
                            :
                        <p className="py-1 pl-3 pr-3 mt-2 text-sm font-bold text-center text-red-800 bg-red-100 rounded-xl ">Masqué</p>
                    }
                </div> 
            </div>
            

            

            <div className="flex flex-row flex-wrap items-start gap-5 mt-5">
               <State
                    value={detail.vu.length}
                    name={'Vus'}
               />

               <State
                    value={detail.comment.length}
                    name={'Comments'}
               />

               <State
                    value={detail.reservation.length}
                    name={'Reservations'}
               />
            </div>

            
                

                
                

                
                
        </div>
    )
}